var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScorpio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.167,
    cy: 64.417,
    r: 2.083,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.167,
    cy: 71.834,
    r: 1.833,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 77.583,
    r: 2.583,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.333,
    cy: 86.168,
    r: 1.667,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 87.334,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.333,
    cy: 84,
    r: 2.167,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.251,
    cy: 72.084,
    r: 3.083,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.333,
    cy: 60.001,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.25,
    cy: 42.75,
    r: 1.75,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.083,
    cy: 39.417,
    r: 2.083,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.417,
    cy: 34.751,
    r: 2.75,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.583,
    cy: 18.642942,
    r: 2.083,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 29.417,
    r: 2.417,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.167,
    cy: 38.167,
    r: 1.667,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.583,
    cy: 49.602981,
    r: 2.25,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M88.333 20.834L90.167 27M91 32l.167 4.334m0 3.5l-1 7.166M77 33.667l11.667-3.5m-20 7.833l3.166-2m-6.5 4.5l-1.666 1.167M61 44.167l-8.667 14m-1.5 3.667l-1 7m-1.5 6l-1.5 7.167m-2.666 2.666L35 87.334m-4 0l-9.833-.833m-3.5-1.334l-5.834-5.833m-.333-4l2.333-2.167m2.834-2.833l4-4.167"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCiA8Zz4KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgPHJlY3QgZmlsbD0ibm9uZSIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjQwMiIgd2lkdGg9IjU4MiIgeT0iLTEiIHg9Ii0xIi8+CiA8L2c+CiA8Zz4KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+CiAgPGNpcmNsZSBpZD0ic3ZnXzcwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgcj0iMi4wODMiIGZpbGw9IiNmZmZmZmYiIGN5PSI2NC40MTciIGN4PSIyMi4xNjciLz4KICA8Y2lyY2xlIGlkPSJzdmdfNzEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiByPSIxLjgzMyIgZmlsbD0iI2ZmZmZmZiIgY3k9IjcxLjgzNCIgY3g9IjE1LjE2NyIvPgogIDxjaXJjbGUgaWQ9InN2Z183MiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIuNTgzIiBmaWxsPSIjZmZmZmZmIiBjeT0iNzcuNTgzIiBjeD0iMTAiLz4KICA8Y2lyY2xlIGlkPSJzdmdfNzMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiByPSIxLjY2NyIgZmlsbD0iI2ZmZmZmZiIgY3k9Ijg2LjE2OCIgY3g9IjE5LjMzMyIvPgogIDxjaXJjbGUgaWQ9InN2Z183NCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGN5PSI4Ny4zMzQiIGN4PSIzMyIvPgogIDxjaXJjbGUgaWQ9InN2Z183NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIuMTY3IiBmaWxsPSIjZmZmZmZmIiBjeT0iODQiIGN4PSI0Ni4zMzMiLz4KICA8Y2lyY2xlIGlkPSJzdmdfNzYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiByPSIzLjA4MyIgZmlsbD0iI2ZmZmZmZiIgY3k9IjcyLjA4NCIgY3g9IjQ5LjI1MSIvPgogIDxjaXJjbGUgaWQ9InN2Z183NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGN5PSI2MC4wMDEiIGN4PSI1MS4zMzMiLz4KICA8Y2lyY2xlIGlkPSJzdmdfNzgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiByPSIxLjc1IiBmaWxsPSIjZmZmZmZmIiBjeT0iNDIuNzUiIGN4PSI2Mi4yNSIvPgogIDxjaXJjbGUgaWQ9InN2Z183OSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIuMDgzIiBmaWxsPSIjZmZmZmZmIiBjeT0iMzkuNDE3IiBjeD0iNjcuMDgzIi8+CiAgPGNpcmNsZSBpZD0ic3ZnXzgwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgcj0iMi43NSIgZmlsbD0iI2ZmZmZmZiIgY3k9IjM0Ljc1MSIgY3g9Ijc0LjQxNyIvPgogIDxjaXJjbGUgaWQ9InN2Z184MSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjIuMDgzIiBmaWxsPSIjZmZmZmZmIiBjeT0iMTguNjQyOTQyIiBjeD0iODcuNTgzIi8+CiAgPGNpcmNsZSBpZD0ic3ZnXzgyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgcj0iMi40MTciIGZpbGw9IiNmZmZmZmYiIGN5PSIyOS40MTciIGN4PSI5MSIvPgogIDxjaXJjbGUgaWQ9InN2Z184MyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIHI9IjEuNjY3IiBmaWxsPSIjZmZmZmZmIiBjeT0iMzguMTY3IiBjeD0iOTEuMTY3Ii8+CiAgPGNpcmNsZSBpZD0ic3ZnXzg0IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgcj0iMi4yNSIgZmlsbD0iI2ZmZmZmZiIgY3k9IjQ5LjYwMjk4MSIgY3g9Ijg5LjU4MyIvPgogIDxsaW5lIGlkPSJzdmdfODUiIHkyPSIyNyIgeTE9IjIwLjgzNCIgeDI9IjkwLjE2NyIgeDE9Ijg4LjMzMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIGZpbGw9Im5vbmUiLz4KICA8bGluZSBpZD0ic3ZnXzg2IiB5Mj0iMzYuMzM0IiB5MT0iMzIiIHgyPSI5MS4xNjciIHgxPSI5MSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIGZpbGw9Im5vbmUiLz4KICA8bGluZSBpZD0ic3ZnXzg3IiB5Mj0iNDciIHkxPSIzOS44MzQiIHgyPSI5MC4xNjciIHgxPSI5MS4xNjciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiBmaWxsPSJub25lIi8+CiAgPGxpbmUgaWQ9InN2Z184OCIgeTI9IjMwLjE2NyIgeTE9IjMzLjY2NyIgeDI9Ijg4LjY2NyIgeDE9Ijc3IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfODkiIHkyPSIzNiIgeTE9IjM4IiB4Mj0iNzEuODMzIiB4MT0iNjguNjY3IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTAiIHkyPSI0MS42NjciIHkxPSI0MC41IiB4Mj0iNjMuNjY3IiB4MT0iNjUuMzMzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTEiIHkyPSI1OC4xNjciIHkxPSI0NC4xNjciIHgyPSI1Mi4zMzMiIHgxPSI2MSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIGZpbGw9Im5vbmUiLz4KICA8bGluZSBpZD0ic3ZnXzkyIiB5Mj0iNjguODM0IiB5MT0iNjEuODM0IiB4Mj0iNDkuODMzIiB4MT0iNTAuODMzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTMiIHkyPSI4Mi4wMDEiIHkxPSI3NC44MzQiIHgyPSI0Ni44MzMiIHgxPSI0OC4zMzMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiBmaWxsPSJub25lIi8+CiAgPGxpbmUgaWQ9InN2Z185NCIgeTI9Ijg3LjMzNCIgeTE9Ijg0LjY2NyIgeDI9IjM1IiB4MT0iNDQuMTY3IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTUiIHkyPSI4Ni41MDEiIHkxPSI4Ny4zMzQiIHgyPSIyMS4xNjciIHgxPSIzMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2U9IiNmZmZmZmYiIGZpbGw9Im5vbmUiLz4KICA8bGluZSBpZD0ic3ZnXzk2IiB5Mj0iNzkuMzM0IiB5MT0iODUuMTY3IiB4Mj0iMTEuODMzIiB4MT0iMTcuNjY3IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTciIHkyPSI3My4xNjciIHkxPSI3NS4zMzQiIHgyPSIxMy44MzMiIHgxPSIxMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIGlkPSJzdmdfOTgiIHkyPSI2Ni4xNjciIHkxPSI3MC4zMzQiIHgyPSIyMC42NjciIHgxPSIxNi42NjciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlPSIjZmZmZmZmIiBmaWxsPSJub25lIi8+CiA8L2c+Cjwvc3ZnPg==";
export { SvgScorpio as ReactComponent };